module.exports = __webpack_public_path__ + "static/media/flip.2598cefc.svg";